@use "variables" as *;

.bar {
  width: 120px;
  height: 8px !important;
  border-radius: 6px;
  margin-right: $spacing-ml !important;
}
